export default __webpack_public_path__ + "static/footer-map-c5a27c2bcc131d32b5791b14dd52d87f.png";